import moment from 'moment';

const ExcelDateToJSDate = (serial: number): Date => {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);

    const fractionalDay = serial - Math.floor(serial) + 0.0000001;

    let totalSeconds = Math.floor(86400 * fractionalDay);

    const seconds = totalSeconds % 60;

    totalSeconds -= seconds;

    const hours = Math.floor(totalSeconds / (60 * 60));
    const minutes = Math.floor(totalSeconds / 60) % 60;

    return new Date(dateInfo.getFullYear(), dateInfo.getMonth(), dateInfo.getDate(), hours, minutes, seconds);
};

const findIndexesInString = (str: string, char: string): number[] => {
    const indices = [];
    for (let i = 0; i < str.length; i++) {
        if (str[i] === char) indices.push(i);
    }
    return indices;
};

const formatDate = (value: string | number): string => {
    if (value) {
        if (typeof value === 'number') {
            const dateValue = ExcelDateToJSDate(value);
            return dateValue.toLocaleDateString();
        }

        if (typeof value === 'string' && findIndexesInString(value, '.').length === 2) {
            return moment(value, 'DD.MM.YYYY').format();
        }
    }
    return value ? String(value) : '';
};

export default formatDate;
